import { render, staticRenderFns } from "./PageFeatures.vue?vue&type=template&id=478c5cc2&scoped=true&"
import script from "./PageFeatures.vue?vue&type=script&lang=js&"
export * from "./PageFeatures.vue?vue&type=script&lang=js&"
import style0 from "./PageFeatures.vue?vue&type=style&index=0&id=478c5cc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478c5cc2",
  null
  
)

export default component.exports